import React from 'react';
import LegalLayout, { COMPANY } from './LegalLayout';

const Refund = () => (
  <LegalLayout title="Refund Policy" lastUpdated="29 May 2026">
    <p data-testid="refund-intro">
      Refunds on {COMPANY.shortName} are governed by the cancellation and refund policy of the
      underlying Supplier (airline, hotel, bus operator, package partner). This policy is shown to
      you before payment and forms part of your booking contract.
    </p>

    <h2>1. How to Initiate a Refund</h2>
    <ul>
      <li>Sign in and visit <a href="/account/bookings">My Bookings</a>.</li>
      <li>Open the booking you wish to cancel and click <strong>Cancel Booking</strong>.</li>
      <li>You will see the applicable cancellation charges and the net refundable amount.</li>
      <li>Confirm to initiate the cancellation; refunds are processed automatically thereafter.</li>
    </ul>

    <h2>2. Refund Timelines</h2>
    <ul>
      <li><strong>Credit / Debit Cards</strong> — 7-10 working days after refund initiation.</li>
      <li><strong>UPI / Net-banking</strong> — 5-7 working days.</li>
      <li><strong>Wallet credits</strong> — instant.</li>
    </ul>

    <h2>3. Service & Convenience Fees</h2>
    <p>{COMPANY.shortName} service fees and convenience charges are <em>non-refundable</em> unless
      the cancellation is caused by us or the Supplier (e.g. flight cancellation by airline,
      hotel overbooking).</p>

    <h2>4. No-Show & Partial Use</h2>
    <p>If you do not check-in/board, the booking is treated as a no-show and is generally
      non-refundable as per Supplier policy.</p>

    <h2>5. Force-Majeure Cancellations</h2>
    <p>In case the Supplier cancels due to events beyond their control, refunds will follow the
      Supplier's standard force-majeure rules. {COMPANY.shortName} will assist in escalation but
      does not guarantee a full refund.</p>

    <h2>6. Payment-Gateway Reversals</h2>
    <p>When a payment fails after deduction (network timeout, bank reversal), the amount is
      automatically returned by the bank within 7 working days. If not received, please email
      {COMPANY.email} with the order id and bank statement.</p>

    <h2>7. Disputes</h2>
    <p>For any refund dispute, please write to <strong>{COMPANY.email}</strong> with your booking
      reference. All disputes are governed by the laws of India and the courts at Bengaluru.</p>
  </LegalLayout>
);

export default Refund;
